import { resolveZoneIdViaAliases } from './zoneDeduplication';

let knownRendererIdAliases: Record<string, string> = {};
export function setRendererIdAliases(aliases: Record<string, string>): void {
  knownRendererIdAliases = aliases;
}

const durableId = (id: string): string => id.trim().toLowerCase().replace(/^uuid:/, '');

/** #11529: the live Connector renderer id for a saved/cloud zone id (folded alias, case or uuid: prefix differences). */
export function resolveLiveRendererId(
  zoneId: string,
  zones: ReadonlyArray<{ id: string }> | undefined,
  aliases: Record<string, string> = knownRendererIdAliases,
): string {
  const live = zones ?? [];
  if (live.some((z) => z.id === zoneId)) return zoneId;
  const viaAlias = resolveZoneIdViaAliases(zoneId, aliases);
  if (viaAlias !== zoneId && live.some((z) => z.id === viaAlias)) return viaAlias;
  const want = durableId(zoneId);
  return live.find((z) => durableId(z.id) === want)?.id ?? zoneId;
}
